import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";

// action types
export const UPDATE_TABLE_STRUCTURE = "getORDERSTableStructure";
export const UPDATE_TABLE_DATA = "getORDERSTableData";
export const EXPORT_TABLE_DATA = "exportORDERSTableData";

// mutation types
export const SET_TABLE_STRUCTURE = "setORDERSTableStructure";
export const SET_TABLE_DATA = "setORDERSTableData";
export const SET_TABLE_FILTER = "setORDERSTableFilter";
// export const SET_FILTER_CHANGE = "setORDERSFilterChange";
export const SET_TABLE_PAGE = "setORDERSTablePage";
export const SET_TABLE_PERPAGE = "setORDERSTablePerPage";
export const SET_TABLE_SORTBY = "setORDERSTableSortBy";
export const SET_TABLE_SORTORDER = "setORDERSTableSortOrder";
export const SET_EXPORT_LINK = "setORDERSExportLink";
export const SET_B2B_CARTONS = "setORDERSCreateB2BCartons";
export const EDIT_B2B_CARTONS = "editORDERSCreateB2BCartons";
export const REMOVE_B2B_CARTONS = "removeORDERSCreateB2BCartons";
export const SET_SHOW_ORDERS_ACTION_BTN =
  "setORDERSIsActionBtnShownInViewOrders";
export const SET_SERVER_DATA_FOR_ORDERS = "setORDERSServerData";

const state = {
  queryObject: {},
  export_link: null,
  table_structure: {},
  table_data: {},
  table_state: {
    page: 1,
    per_page: 50,
    sortBy: "id",
    sortOrder: "desc",
    filters: [],
  },
  createB2BCartons: [],
  isActionBtnShownInViewOrders: false,
  serverData: {},
};

const getters = {
  /**
   * for table title, description
   * */
  getORDERSTableProperties(state) {
    return state.table_structure.properties;
  },
  /**
   * for table permissions
   **/
  getORDERSTablePermissions(state) {
    return state.table_structure.permissions;
  },
  getORDERSPrintTypes(state) {
    return state.table_structure.print_labels;
  },
  getORDERSExampleFiles(state) {
    return state.table_structure.files;
  },
  getORDERSTableState(state) {
    return state.table_state;
  },
  getORDERSTableHeaders(state) {
    return state.table_structure.columns;
  },

  getORDERSTableFilters(state) {
    return state.table_structure.filters;
  },

  getORDERSTableData(state) {
    return state.table_data.data;
  },

  getORDERSExportUrl(state) {
    return state.export_link;
  },
  getORDERSCallStatuses(state) {
    // console.log(state, state.table_structure.call_statuses[0]);
    return state.table_structure.call_statuses[0];
  },
  getORDERSUploadType(state) {
    return state.table_structure.types;
  },
  getORDERSExtraData(state) {
    return state.table_structure.reason_data;
  },
  getORDERSCarriers(state) {
    return state.table_structure.carriers;
  },
  getORDERSCarrierAccounts(state) {
    return state.table_structure.carrier_accounts;
  },
  getORDERSCreateB2BCartons(state) {
    return state.createB2BCartons;
  },
  getORDERSIsActionBtnShownInViewOrders(state) {
    return state.isActionBtnShownInViewOrders;
  },
  getORDERSServerData(state) {
    return state.serverData;
  },
};

const actions = {
  [UPDATE_TABLE_STRUCTURE](context) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/fulfillment/orders")
        .then(({ data }) => {
          context.commit(SET_TABLE_STRUCTURE, data);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/fulfillment/orders/datatable", payload)
        .then(({ data }) => {
          context.commit(SET_TABLE_DATA, data);
          resolve(data);
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [EXPORT_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/fulfillment/orders/export", payload)
        .then(({ data }) => {
          context.commit(SET_EXPORT_LINK, data.url);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
};

const mutations = {
  [SET_SERVER_DATA_FOR_ORDERS](state, serverData) {
    state.serverData = serverData;
  },
  [SET_SHOW_ORDERS_ACTION_BTN](state, isActionBtnShownInViewOrders) {
    state.isActionBtnShownInViewOrders = isActionBtnShownInViewOrders;
  },
  [SET_TABLE_FILTER](state, filter) {
    state.table_state.filters = filter;
  },
  [SET_B2B_CARTONS](state, data) {
    if (Array.isArray(data)) state.createB2BCartons = data;
    else state.createB2BCartons.push(data);
  },
  [EDIT_B2B_CARTONS](state, data) {
    state.createB2BCartons.splice(data.lastElementIndex, 1, data.newItem);
  },
  [REMOVE_B2B_CARTONS](state, index) {
    state.createB2BCartons.splice(index, 1);
  },

  [SET_TABLE_PAGE](state, page) {
    state.table_state.page = page;
  },
  [SET_TABLE_PERPAGE](state, perPage) {
    state.table_state.per_page = perPage;
  },
  [SET_TABLE_SORTBY](state, sortBy) {
    state.table_state.sortBy = sortBy;
  },
  [SET_TABLE_SORTORDER](state, sortOrder) {
    state.table_state.sortOrder = sortOrder;
  },
  [SET_TABLE_STRUCTURE](state, table_structure) {
    state.table_structure = table_structure.data;
  },
  [SET_TABLE_DATA](state, table_data) {
    state.table_data = table_data;
  },
  [SET_EXPORT_LINK](state, link) {
    state.export_link = link;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
